import { render } from "./ubuntu_body_main.vue?vue&type=template&id=f2ef7780"
import script from "./ubuntu_body_main.vue?vue&type=script&lang=js"
export * from "./ubuntu_body_main.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__